// Auto-extracted from AI RAC Product Offering.csv (Model Number column)
export default [
  "A1C-06N2-M1",
  "A1C-09N2-M1",
  "A1C-12N2-M1",
  "A1C-18N2-M1",
  "A3MO21-18N2-M1",
  "A3MO23-18N2-M1H",
  "A4MO21-27N2-M1",
  "A4MO23-27N2-M1H",
  "A5MO21-36N2-M1",
  "A5MO23-36N2-M1H",
  "A6MO21-48N2-M1",
  "A6MO21-60N2-M1",
  "A6MO23-48N2-M1H",
  "A6MO23-55N2-M1H",
  "AAH-18N2-BM1",
  "AAH-24N2-BM1",
  "AAH-30N2-CM1",
  "AAH-36N2-CM1",
  "AAH-36N2-CM2",
  "AAH-48N2-DM2",
  "AAH-60N2-DM2",
  "AC-09N2-M1",
  "AC-12N2-M1",
  "AC-18N2-M1",
  "AC-24N2-M1",
  "AC-36N2-M1",
  "AC-48N2-M1",
  "AF-18N2-M1",
  "AF-24N2-M1",
  "AF-36N2-M1",
  "AF-48N2-M1",
  "AF-60N2-M1",
  "AH-09N2-M1",
  "AH-12N2-M1",
  "AH-18N2-M1",
  "AH-24N2-M1",
  "AH-36N2-M1",
  "AH-48N2-M1",
  "AH-60N2-M1",
  "AL-06N2-M1",
  "AL-09N2-M1",
  "AL-12N2-M1",
  "AL-18N2-M1",
  "AO21-09N2-B1",
  "AO21-09N2-M1",
  "AO21-12N2-B1",
  "AO21-12N2-M1",
  "AO21-18N2-M1",
  "AO21-24N2-M1",
  "AO21-30N2-M1",
  "AO21-36N2-M1",
  "AO24-09N2-B1H",
  "AO24-09N2-M1",
  "AO24-12N2-B1H",
  "AO24-12N2-M1",
  "AO24-18N2-M1",
  "AO24-24N2-M1",
  "AO25-06N2-M1H",
  "AO25-09N2-M1H",
  "AO25-12N2-M1H",
  "AO25-18N2-M1H",
  "AO25-24N2-M1H",
  "AO25-33N2-M1H",
  "AO35-06N2-M1H",
  "AO35-09N2-M1H",
  "AO35-12N2-M1H",
  "AO35-18N2-M1H",
  "AP-4CP22-03B",
  "AP-4CP33-04B",
  "AS-09N2-M1",
  "AS-12N2-M1",
  "AS-16N2-M1",
  "ASO24-36N2-M2",
  "ASO24-48N2-M2",
  "ASO24-60N2-M2",
  "ASO25-36N2-M2H",
  "ASO25-48N2-M2H",
  "ASO25-60N2-M2H",
  "AUA-24N2-A18",
  "AUA-24N2-B18",
  "AUA-36N2-A24",
  "AUA-36N2-B24",
  "AUA-36N2-C24",
  "AUA-60N2-D28",
  "AUE-18N2-MM3E",
  "AUE-24N2-MM3E",
  "AUE-30N2-LM3E",
  "AUE-36N2-LM3E",
  "AUH2-18N2-BM3E",
  "AUH2-24N2-BM3E",
  "AUH2-30N2-CM3E",
  "AUH2-36N2-CM3E",
  "AUH2-48N2-DM3E",
  "AUH2-60N2-DM3E",
  "AUH3-18N2-AM3E",
  "AUH3-24N2-AM3E",
  "AUH3-30N2-BM3E",
  "AUH3-36N2-BM3E",
  "AUH3-48N2-CM3E",
  "AUH3-60N2-CM3E",
  "AUM-60N2-C28",
  "AUO18-18N2-M3",
  "AUO18-24N2-M3",
  "AUO18-30N2-M3",
  "AUO18-36N2-M3",
  "AUO18-48N2-M3",
  "AUO18-60N2-M3",
  "AUO19-18N2-M3H",
  "AUO19-24N2-M3H",
  "AUO19-30N2-M3H",
  "AUO19-36N2-M3H",
  "AUO19-36N2-M3H-S",
  "AUO19-42N2-M3H-S",
  "AUO19-48N2-M3H",
  "AUO19-48N2-M3H-S",
  "AUO19-60N2-M3H",
  "AUP-18N2-HM3",
  "AUP-24N2-IM3",
  "AUP-30N2-JM3",
  "AUP-36N2-KM3",
  "AW21-09N2-B1",
  "AW21-09N2-M1",
  "AW21-12N2-B1",
  "AW21-12N2-M1",
  "AW21-18N2-M1",
  "AW21-24N2-M1",
  "AW21-30N2-M1",
  "AW21-36N2-M1",
  "AW24-09N2-B1",
  "AW24-12N2-B1",
  "AW25-06N2-M1",
  "AW25-09N2-M1",
  "AW25-12N2-M1",
  "AW25-18N2-M1",
  "AW25-24N2-M1",
  "AW25-33N2-M1",
  "AW35-06N2-M1",
  "AW35-09N2-M1",
  "AW35-12N2-M1",
  "AW35-18N2-M1",
  "EAH-03C(UL)",
  "EAH-03D(UL)",
  "EAH-03E(UL)",
  "EAH-03F(UL)",
  "EAH-05C(UL)",
  "EAH-05D(UL)",
  "EAH-05E(UL)",
  "EAH-05F(UL)",
  "EAH-08C(UL)",
  "EAH-08D(UL)",
  "EAH-08E(UL)",
  "EAH-08F(UL)",
  "EAH-10C(UL)",
  "EAH-10D(UL)",
  "EAH-10E(UL)",
  "EAH-10F(UL)",
  "EAH-15E(UL)",
  "EAH-15F(UL)",
  "EAH-20E(UL)",
  "EAH-20F(UL)",
  "EAH-25E(UL)",
  "EAH-25F(UL)"
];
